<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.8333 9.34175L18.6583 8.16675L14 12.8251L9.34167 8.16675L8.16667 9.34175L12.825 14.0001L8.16667 18.6584L9.34167 19.8334L14 15.1751L18.6583 19.8334L19.8333 18.6584L15.175 14.0001L19.8333 9.34175Z"
      fill="currentColor"
    />
  </svg>
</template>
